import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Dialog } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { images } from "../utils/images";
import {
  pushNotification,
  createInstitution,
  submitInstitutionDirectors,
  submitBankDetails,
  submitInstitutionDocuments,
  submitInstitutionOwners,
} from "../actions/index";

// Components
import StepTrackerCorporate from "../components/CorporatePage/StepTrackerCorporate";
import BusinessDetails from "../components/CorporatePage/BusinessDetails";
import BusinessAddress from "../components/CorporatePage/BusinessAddress";
import AboutBusinesss from "../components/CorporatePage/AboutBusiness";
import BankDetails from "../components/CorporatePage/BankDetails";
import DirectorsAndOwners from "../components/CorporatePage/DirectorsAndOwners";
import BusinessDocuments from "../components/CorporatePage/BusinessDocuments";
import DocumentReview from "../components/UpgradePage/DocumentReview";
import CorporateRejected from "../components/CorporatePage/CorporateRejected";

import Loader from "../components/Loader";

const urlSolo = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_DASHBOARD;

function CorporateContainer(props) {
  const { t, classes, account, institutional } = props;
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [exitConfirmation, setExitConfirmation] = useState(false);
  const [triggerCreateRequest, setTriggerCreateRequest] = useState(false);
  const [triggerBankRequest, setTriggerBankRequest] = useState(false);
  const [triggerRepsRequest, setTriggerRepsRequest] = useState(false);
  const [triggerDocumentsRequest, setTriggerDocumentsRequest] = useState(false);
  const [uploadingDocs, setUploadingDocs] = useState(false);

  // Business details info
  const [businessDetails, setBusinessDetails] = useState(null);
  // Business Address
  const [businessAddress, setBusinessAddress] = useState(null);
  // About Business
  const [aboutBusiness, setAboutBusiness] = useState(null);
  // Bank Details
  const [bankDetails, setBankDetails] = useState(null);
  // Directos
  const [directors, setDirectors] = useState(null);
  // Owners
  const [owners, setOwners] = useState(null);
  // Documents
  const [documents, setDocuments] = useState(null);

  // ComponentDidMount
  useEffect(() => {
    document.body.style.background = "#262626";

    return () => {
      document.body.style.background = "#262626";
      setStep(1);
    };
  }, []);

  useEffect(() => {
    if (institutional.updated) {
      if (institutional.institution) {
        const { institution } = institutional;

        if (institution.status === "approved") {
          return props.history.push("/id/settings");
        }

        if (institution.status === "rejected") {
          setStep(9);
          return setLoading(false);
        }

        if (institution.banks.length === 0) {
          setStep(4);
          return setLoading(false);
        }

        if (institution.representatives.length === 0) {
          setStep(5);
          return setLoading(false);
        }

        if (institution.documents.length === 0) {
          setStep(7);
          return setLoading(false);
        }

        if (institution.documents.length) {
          setUploadingDocs(false);
          setStep(8);
          return setLoading(false);
        }
      } else {
        setStep(1);
        setLoading(false);
      }
    }
  }, [institutional]);

  useEffect(() => {
    if (account.account !== null) {
      if (account.account.level < 6) {
        props.history.push("/id/settings");
      }
    }
  }, [account]);

  // Trigger Create Request
  useEffect(() => {
    if (triggerCreateRequest) {
      let institutionObj = {
        ...businessDetails,
        ...businessAddress,
        ...aboutBusiness,
      };

      props.createInstitution(institutionObj);
    }
  }, [triggerCreateRequest]);

  // Trigger Bank Request
  useEffect(() => {
    if (triggerBankRequest) {
      props.submitBankDetails([bankDetails]);
    }
  }, [triggerBankRequest]);

  // Trigger Reps Request
  useEffect(() => {
    if (triggerRepsRequest) {
      let reps = [...directors, ...owners];
      props.submitInstitutionDirectors(reps);
    }
  }, [triggerRepsRequest]);

  // Trigger Documents Request
  useEffect(() => {
    if (triggerDocumentsRequest) {
      props.submitInstitutionDocuments(documents);
      setUploadingDocs(true);
    }
  }, [triggerDocumentsRequest]);

  // Leave form
  const exit = () => {
    setExitConfirmation(true);
  };

  // Move Forward
  const moveForward = () => {
    setStep(step + 1);
  };

  if (loading) {
    return (
      <div className={classes.corporateContainer}>
        <div className={classes.soloLogo}>
          <img
            style={{ cursor: "pointer" }}
            src={images.logos.sologenicWhiteLogo}
            onClick={() => (window.location.href = urlSolo)}
          />
        </div>
        <div className="loading">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.corporateContainer}>
      <div className={classes.soloLogo}>
        <img
          style={{ cursor: "pointer" }}
          src={images.logos.sologenicWhiteLogo}
          onClick={() => (window.location.href = urlSolo)}
        />
      </div>
      {step >= 8 ? "" : <StepTrackerCorporate step={step} />}
      {step >= 8 ? (
        ""
      ) : (
        <div className="exitBtn">
          <button
            onClick={() => {
              exit();
            }}
          >
            {t("exit")}
          </button>
        </div>
      )}
      <div
        className="stepContent"
        style={step >= 8 ? { padding: 0, marginTop: "10%" } : {}}
      >
        {step === 1 ? (
          <BusinessDetails
            moveForward={moveForward}
            setBusinessDetails={setBusinessDetails}
            pushNotification={props.pushNotification}
          />
        ) : (
          ""
        )}
        {step === 2 ? (
          <BusinessAddress
            moveForward={moveForward}
            setBusinessAddress={setBusinessAddress}
          />
        ) : (
          ""
        )}
        {step === 3 ? (
          <AboutBusinesss
            trigger={setTriggerCreateRequest}
            setAboutBusiness={setAboutBusiness}
            pushNotification={props.pushNotification}
          />
        ) : (
          ""
        )}
        {step === 4 ? (
          <BankDetails
            trigger={setTriggerBankRequest}
            setBankDetails={setBankDetails}
          />
        ) : (
          ""
        )}
        {step === 5 ? (
          <DirectorsAndOwners
            moveForward={moveForward}
            setDirectors={setDirectors}
          />
        ) : (
          ""
        )}
        {step === 6 ? (
          <DirectorsAndOwners
            owners
            trigger={setTriggerRepsRequest}
            setDirectors={setOwners}
          />
        ) : (
          ""
        )}
        {step === 7 ? (
          <BusinessDocuments
            pushNotification={props.pushNotification}
            setDocuments={setDocuments}
            trigger={setTriggerDocumentsRequest}
          />
        ) : (
          ""
        )}
        {step === 8 ? <DocumentReview onBusiness /> : ""}
        {step === 9 ? <CorporateRejected router={props.history} /> : ""}
      </div>
      <Dialog
        open={uploadingDocs}
        classes={{ paper: classes.cancelConfirmationM }}
      >
        <div className="cancelHeader">
          <p>{t("_uploading")}</p>
        </div>
        <div className="cancelBody">
          <Loader />
        </div>
      </Dialog>
      <Dialog
        open={exitConfirmation}
        classes={{ paper: classes.cancelConfirmation }}
        scroll="body"
      >
        <div className="cancelHeader profileHeader">
          <p>{t("confirmation")}</p>
        </div>
        <div className="cancelBody">
          <p dangerouslySetInnerHTML={{ __html: t("sureToCancelCorporate") }} />
          <div className="btns">
            <button
              className="cancelBtn"
              onClick={() => setExitConfirmation(false)}
            >
              {t("cancel")}
            </button>
            <button
              className="confirmBtn"
              onClick={() => {
                setExitConfirmation(false);
                props.history.push("/id/settings");
              }}
            >
              {t("confirm")}
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
    institutional: state.institutional,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      pushNotification,
      createInstitution,
      submitBankDetails,
      submitInstitutionDirectors,
      submitInstitutionDocuments,
      submitInstitutionOwners,
    },
    dispatch
  );
}

const styles = (theme) => ({
  soloLogo: {
    width: "100%",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    position: "relative",
    "& img": {
      width: 180,
      height: "auto",
    },
  },
  corporateContainer: {
    paddingTop: 64,
    marginBottom: 64,
    "& .exitBtn": {
      width: "90%",
      maxWidth: 800,
      display: "flex",
      justifyContent: "flex-end",
      margin: "8px auto",
      "& button": {
        background: "none",
        color: theme.colors.buttons.sell,
        cursor: "pointer",
        transition: ".3s",
        fontSize: 18,
        border: "none",
        "&:hover": {
          opacity: 0.3,
        },
      },
    },
    "& .stepContent": {
      width: "95%",
      maxWidth: 880,
      marginLeft: "auto",
      marginRight: "auto",
      borderRadius: 2,
      background: theme.colors.background.fore,
      padding: 40,
      height: "auto",
      boxShadow: theme.defaults.shadow,

      [theme.breakpoints.down(500)]: {
        padding: 24,
      },
      "& .corporateStepContainer": {
        "& h2": {
          fontSize: 28,
          marginBottom: 8,
          color: theme.colors.text.primary,
        },
        "& p": {
          fontSize: 14,
          lineHeight: "21px",
          color: theme.colors.text.secondary,
          "&.label": {
            color: theme.colors.text.primary,
            fontWeight: 700,
          },
        },
        "& input::placeholder": {
          fontSize: 14,
          lineHeight: "21px",
          color: theme.colors.text.secondary,
        },

        "& .inputsContainer": {
          display: "flex",
          justifyContent: "space-between",
          marginTop: 40,

          "& .left": {
            width: "55%",
          },
          "& .right": {
            width: "35%",
            display: "flex",
            justifyContent: "center",
            "& img": {
              width: "100%",
              height: "auto",
              objectFit: "contain",
            },
          },

          [theme.breakpoints.down(768)]: {
            flexDirection: "column",
            "& .left, & .right": {
              width: "100%",
              "& img": {
                display: "none",
              },
            },
          },
        },
        "& .nextButtonContainer": {
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginTop: 40,
          "& button": {
            ...theme.defaults.roundBtn,
            background: theme.colors.buttons.green,
          },
        },
      },
    },
  },
  cancelConfirmation: {
    width: "95%",
    maxWidth: 400,
    background: theme.colors.background.lightFore,
    borderRadius: 2,
    margin: 0,
    "& .cancelHeader": {
      background: theme.colors.background.fore,
      height: 75,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& p": {
        color: theme.colors.text.primary,
        fontSize: 18,
      },
      "&.profileHeader": {
        fontWeight: 600,
      },
    },
    "& .cancelBody": {
      padding: "24px 40px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      [theme.breakpoints.down(400)]: {
        padding: 24,
      },
      "& p": {
        color: theme.colors.text.primary,
        fontSize: 14,
        // fontFamily: "Titillium Web",
        lineHeight: "21px",
      },
      "& .btns": {
        display: "flex",
        justifyContent: "flex-end",
        widht: "100%",
        marginTop: 32,
        "& button": theme.defaults.roundBtn,
        "& .cancelBtn": {
          background: "none",
          border: `1px solid ${theme.colors.text.primary}`,
          marginRight: 16,
          color: theme.colors.text.primary,
        },
        "& .confirmBtn": {
          background: theme.colors.buttons.green,
          border: "1px solid transparent",
        },
        "&.profileBtns": {
          "& button": {
            padding: "0 12px",
          },
        },
        [theme.breakpoints.down(400)]: {
          justifyContent: "center",
        },
      },
    },
  },
  cancelConfirmationM: {
    width: "95%",
    maxWidth: 300,
    background: theme.colors.background.lightFore,
    borderRadius: 2,
    margin: 0,
    "& .cancelHeader": {
      background: theme.colors.background.fore,
      height: 75,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& p": {
        color: theme.colors.text.primary,
        fontSize: 18,
      },
      "&.profileHeader": {
        fontWeight: 600,
      },
    },
    "& .cancelBody": {
      padding: 40,
      [theme.breakpoints.down(400)]: {
        padding: 24,
      },
      "& p": {
        color: theme.colors.text.primary,
        fontSize: 14,
        // fontFamily: "Titillium Web",
        lineHeight: "21px",
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(CorporateContainer)
  )
);
